export default {
  bind: function (el) {
    el.addEventListener('focus', function (event) {
      if (typeof this.select !== 'function') {
        return;
      }
      this.select();
    });
  }
}